import {
  API_USR_GET_ENTITIES_REQUEST,
  API_USR_GET_ENTITIES_SUCCESS,
  API_USR_GET_ENTITIES_FAILURE,
} from 'common/types';
import _ from 'lodash';

const initialState = {
  entitiesData: null,
};

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [API_USR_GET_ENTITIES_REQUEST]: (state) => {
    return {
      ...state,
    };
  },
  [API_USR_GET_ENTITIES_SUCCESS]: (state, action) => {
    return {
      ...state,
      entitiesData: action.payload,
    };
  },
  [API_USR_GET_ENTITIES_FAILURE]: (state, action) => {
    return {
      ...state,
      error: 'Failed to get user entities',
    };
  },
};

// ------------------------------------
// Reducer
// ------------------------------------
export default (state = initialState, action) => {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
};
